import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
    addAllergy,
    getAllergysError,
    getAllergysStatus,
    getAllergysLoading,
    getAllergysSuccess,
} from "../../features/allergySlice";
import { useNavigate } from "react-router-dom";
import BackButton from "../../components/backButton";
import Header from "../../components/Header";
import AllergyForm from "./allergyForm";
import RestaurantAppBar from "../../components/restaurantTopBar";
import {
  appendImageFormFields,
} from "../../global/functions/imageHelper";
import { useTranslation } from "react-i18next";

const AddAllergy = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const status = useSelector(getAllergysStatus);
    const error = useSelector(getAllergysError);
    const loading = useSelector(getAllergysLoading);
    const success = useSelector(getAllergysSuccess);
    const [previewImage, setPreviewImage] = useState(null);

    const initialValues = {
        name: "",
        icon: "",
    };

    const handleFormSubmit = (values) => {
        const formData = new FormData();
        formData.append("name", values.name);

        const hasImage = appendImageFormFields(formData, previewImage, "icon");
        if (!hasImage) {
            toast.error("Veuillez sélectionner une icône.");
            return;
        }

        dispatch(addAllergy(formData));
    };

    useEffect(() => {
        if (status === "addSuccess") {
            navigate("/allergy");
            toast.success(success);
        } else if (status === "addError") {
            toast.error(error);
        }
    }, [status, error, dispatch, navigate, success]);

    return (
        <div className="main-application">
            <RestaurantAppBar />
            <Box m="20px" className="main-application">
                <BackButton />
                <Header title={t("headers.addAllergy")} subtitle={t("headers.addAllergySub")} />
                <AllergyForm
                    buttonText={t("common.submit")}
                    handleFormSubmit={handleFormSubmit}
                    initialValues={initialValues}
                    previewImage={previewImage}
                    setPreviewImage={setPreviewImage}
                    loading={loading}
                />
            </Box>
        </div>
    );
};

export default AddAllergy;
